import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const ErrorModal = ({ getRef }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [titleS, setTitleS] = useState('');

  useEffect(() => {
    const ref = {
      open: (soz) => {
        setIsOpen(true);
        setTitleS(soz);
      },
      close: () => setIsOpen(false),
    };
    getRef(ref);
  }, []);

  const onClose = () => {
    setIsOpen(false);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent
        mx="auto" 
        my="auto"
      >
        <ModalHeader>{t('Xatolik')}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text>{titleS}</Text>
        </ModalBody>

        <ModalFooter>
          <Button
            backgroundColor="red.600"
            color={'white'}
            mr={3}
            onClick={onClose}
          >
            {t('Tushunarli')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ErrorModal;
